import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {
    initializationAchievements,
    addAchievement,
    removeAchievement,
    saveAchievements,
    unmountAchievements,
} from "@componentDP/js_react/redux/actions/achievements";
import Achievement from "./achievement";
import {getDataListFromRefsList , getLabelType} from "@helpers/functions";
import LoadingDocuments from "../skeletons/loading_documents";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import HelperText from "../simple/helper_text";
import DeleteConfirmDialog from './delete_confirm_dialog';
import {withTranslation} from 'react-i18next';

class Achievements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numExpandedPanel: 0,
            isOpenDeleteConfirmDialog: false,
            docUuidDeleteConfirmDialog: '',
        };
        this.addAchievement = this.addAchievement.bind(this);
        this.save = this.save.bind(this);
        this.handleChangePanel = this.handleChangePanel.bind(this);
        this.handleOpenDeleteConfirmDialog = this.handleOpenDeleteConfirmDialog.bind(this);
        this.handleCloseDeleteConfirmDialog = this.handleCloseDeleteConfirmDialog.bind(this);
        this.handleContinueDeleteConfirmDialog = this.handleContinueDeleteConfirmDialog.bind(this);
        const {initializationAchievements} = this.props;
        initializationAchievements();
    }
    addAchievement() {
        const {addAchievement} = this.props;
        addAchievement();
    }
    save(refsList) {
        const {schemesAchievements, saveAchievements, t} = this.props;
        let dataList = getDataListFromRefsList(refsList, schemesAchievements);
        if (dataList.length) {
            saveAchievements(dataList, t);
        }
    }
    componentWillUnmount() {
        const {unmountAchievements} = this.props;
        unmountAchievements();
    }
    handleChangePanel = (numPanel) => {
        const state = this.state;
        this.setState({...state, numExpandedPanel: numPanel === state.numExpandedPanel ? -1 : numPanel});
    };
    handleOpenDeleteConfirmDialog(docUuid) {
        const state = this.state;
        this.setState({...state, isOpenDeleteConfirmDialog: true, docUuidDeleteConfirmDialog: docUuid});
    };
    handleCloseDeleteConfirmDialog() {
        const state = this.state;
        this.setState({...state, isOpenDeleteConfirmDialog: false, docUuidDeleteConfirmDialog: ''});
    };
    handleContinueDeleteConfirmDialog() {
        const {removeAchievement, t} = this.props;
        const state = this.state;
        removeAchievement(state.docUuidDeleteConfirmDialog, t);
        this.setState({...state, isOpenDeleteConfirmDialog: false, docUuidDeleteConfirmDialog: ''});
    };
    render() {
        const { classes, i18n, t } = this.props;
        const {
            addAchievement,
            save,
            handleChangePanel,
            handleOpenDeleteConfirmDialog,
            handleCloseDeleteConfirmDialog,
            handleContinueDeleteConfirmDialog,
        } = this;
        const {numExpandedPanel, isOpenDeleteConfirmDialog} = this.state;
        const {
            achievements,
            typesAchievements,
            loadingAchievements,
            loadedAchievements,
        } = this.props;
        let refsList = [];
        const isLangEn = i18n.language === 'en'
        return(
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" align={"left"}>Индивидуальные достижения</Typography>
                </Grid>
                <Grid item xs={12}>
                    {isLangEn
                        ? <>
                            <HelperText
                                message="Provide documentation of your individual achievements if the institution's
                                 Admission Rules award additional points for such accomplishments."/>
                            <HelperText
                                message="Note: If documents already appear in other sections of your application,
                                 you do not need to resubmit or remove them."/>
                        </>
                        : <>
                            <HelperText
                                message="Заполните информацию, подтверждающую индивидуальные достижения, если Правилами приёма
                                    образовательной организации установлено начисление дополнительных баллов за индивидуальные
                                    достижения."/>
                            <HelperText
                                message="Если в списке отображаются документы, которые ранее были добавлены в других закладках,
                                    то добавлять копию или удалять эти документы не нужно."/>
                        </>
                    }
                </Grid>
                <Grid item xs={12}>
                    {loadingAchievements || !loadedAchievements
                        ? <LoadingDocuments />
                        : <Grid container spacing={2}>
                            {achievements.map((achievement, numAchievement) => {
                                refsList[numAchievement] = {};
                                const typeAchievement = getLabelType(achievement, typesAchievements);
                                return (
                                    <Grid item xs={12} key={achievement.uuid}>
                                        <Accordion
                                            expanded={numExpandedPanel === numAchievement}
                                            onChange={() => {
                                                handleChangePanel(numAchievement);
                                            }}
                                            className={classes.panel}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <div className={classes.columnTitle}>
                                                    <Typography>
                                                        {typeAchievement
                                                            ? typeAchievement.value
                                                            : `${t('achievement')} ${numAchievement + 1}`}
                                                    </Typography>
                                                </div>
                                                <div className={`${classes.columnControl} ${classes.alignRight}`}>
                                                    <IconButton
                                                        aria-label="delete"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenDeleteConfirmDialog(achievement.uuid);
                                                        }}>
                                                        <Close />
                                                    </IconButton>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <input type="hidden" ref={input => refsList[numAchievement]['uuid'] = input} value={achievement.uuid} />
                                                <Achievement achievement={achievement} refs={refsList[numAchievement]} />
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12}>
                                <Button variant="outlined" size="small" onClick={addAchievement}>{t('add_achievement')}</Button>
                            </Grid>
                            <Grid item xs={12} className={classes.alignRight}>
                                <Button variant="contained" color="primary" onClick={() => {save(refsList)}}>
                                    {t('save')}
                                </Button>
                            </Grid>
                        </Grid>}
                </Grid>
                <DeleteConfirmDialog
                    isOpen={isOpenDeleteConfirmDialog}
                    handleClose={handleCloseDeleteConfirmDialog}
                    handleContinue={handleContinueDeleteConfirmDialog} />
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        schemesAchievements: state.schemesAchievements,
        achievements: state.achievements,
        typesAchievements: state.typesAchievements,
        loadingAchievements: state.loadingAchievements,
        loadedAchievements: state.loadedAchievements,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initializationAchievements,
        addAchievement,
        removeAchievement,
        saveAchievements,
        unmountAchievements,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Achievements));
